<template>
    <div>
        <section class="modal-card-body">
            <div
                v-html="successfulMessage"
            ></div>
        </section>
        <footer class="modal-card-foot">
            <button
                class="button"
                @click="closeModal"
            >
                {{ trans.button_close }}
            </button>
        </footer>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "PublishArticleSuccessfullBody",
    computed: {
        ...mapGetters('bx24ActivityStreamManager', [
            'trans',
            'routes',
            'articleUrl',
        ]),
        successfulMessage() {
            let articleUrl = this.articleUrl;

            return Utils.replaceWildcards(
                this.trans.publishing_successful,
                {url: articleUrl}
            );
        },
    },
    methods: {
        ...mapActions('bx24ActivityStreamManager', {
            hideModal: 'hidePublishArticleMainModalModal',
        }),
        closeModal() {
            this.hideModal();
        },
    },
}
</script>

<style scoped>
    .bulma .modal-card-body {
        display: inherit;
    }
</style>
